<template>
    <div>
      <AlertTable
        :canEdit="true"
        editRoute="SuperAdminClinicEdit"
        createRoute="SuperAdminClinicCreate"
      />
    </div>
  </template>
  
<script>
import AlertTable from '../../components/alerts/alertTable.vue';

export default {
  components: {
    AlertTable,
  },
  data: () => ({}),
};
</script>
  